import React from 'react';

export const AppIconsRow = (): React.JSX.Element => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 344 44">
			<g clipPath="url(#a)">
				<path
					fill="#c97cf4"
					d="M302.727 10.61c.386-5.51 5.164-9.664 10.674-9.279l19.951 1.395c5.509.386 9.663 5.164 9.278 10.674l-1.395 19.951c-.385 5.51-5.164 9.663-10.673 9.278l-19.952-1.395c-5.509-.385-9.663-5.164-9.278-10.673z"
				/>
				<g clipPath="url(#b)">
					<path
						fill="#101214"
						d="M324.575 10.844a16.7 16.7 0 0 0 9.547.667c.284-.042.458.157.376.432-1.13 3.194-1.34 6.202-.666 9.522.045.253-.157.457-.43.344a17.86 17.86 0 0 0-9.548-.668c-.255.076-.457-.156-.347-.398 1.068-3.198 1.278-6.207.666-9.522-.074-.286.157-.457.402-.377m.468 11.627-.037.527c-.171 2.45-2.008 4.13-4.122 3.982a3.8 3.8 0 0 1-3.528-4.08c.148-2.11 1.975-3.665 4.37-3.497l.622.043.518-7.413a9 9 0 0 0-.93-.096 11.274 11.274 0 0 0-12.045 10.472c-.436 6.235 4.252 11.58 10.472 12.015s11.64-4.235 12.074-10.438l.069-.993z"
					/>
				</g>
			</g>
			<rect width="40" height="40" x="271.981" y="1.98" fill="#fff" rx="10" />
			<rect
				width="39.167"
				height="39.167"
				x="272.398"
				y="2.397"
				stroke="#000"
				strokeOpacity=".1"
				strokeWidth=".833"
				rx="9.583"
			/>
			<path fill="#fff" fillOpacity=".01" d="M279.481 9.48h25v25h-25z" />
			<path
				fill="#e01e5a"
				d="M284.734 25.279a2.633 2.633 0 0 1-2.627 2.626 2.633 2.633 0 0 1-2.626-2.626 2.633 2.633 0 0 1 2.626-2.627h2.627zM286.057 25.279a2.633 2.633 0 0 1 2.626-2.627 2.63 2.63 0 0 1 2.626 2.627v6.575a2.63 2.63 0 0 1-2.626 2.627 2.633 2.633 0 0 1-2.626-2.627z"
			/>
			<path
				fill="#36c5f0"
				d="M288.683 14.733a2.633 2.633 0 0 1-2.626-2.626 2.633 2.633 0 0 1 2.626-2.627 2.63 2.63 0 0 1 2.626 2.627v2.626zM288.683 16.056a2.63 2.63 0 0 1 2.626 2.626 2.63 2.63 0 0 1-2.626 2.626h-6.576a2.633 2.633 0 0 1-2.626-2.626 2.633 2.633 0 0 1 2.626-2.626z"
			/>
			<path
				fill="#2eb67d"
				d="M299.229 18.682a2.633 2.633 0 0 1 2.626-2.626 2.633 2.633 0 0 1 2.626 2.626 2.633 2.633 0 0 1-2.626 2.626h-2.626zM297.905 18.682a2.63 2.63 0 0 1-2.626 2.627 2.633 2.633 0 0 1-2.626-2.627v-6.575a2.633 2.633 0 0 1 2.626-2.627 2.63 2.63 0 0 1 2.626 2.627z"
			/>
			<path
				fill="#ecb22e"
				d="M295.279 29.228a2.63 2.63 0 0 1 2.626 2.626 2.63 2.63 0 0 1-2.626 2.626 2.633 2.633 0 0 1-2.626-2.626v-2.626zM295.279 27.905a2.633 2.633 0 0 1-2.626-2.626 2.633 2.633 0 0 1 2.626-2.627h6.576a2.633 2.633 0 0 1 2.626 2.627 2.633 2.633 0 0 1-2.626 2.626z"
			/>
			<path
				fill="#1868db"
				d="M241.045 14.126c-.577-5.493 3.408-10.413 8.9-10.99l19.891-2.091c5.492-.577 10.413 3.407 10.99 8.9l2.091 19.89c.577 5.493-3.408 10.413-8.9 10.99l-19.891 2.091c-5.492.578-10.413-3.407-10.99-8.9z"
			/>
			<g clipPath="url(#c)">
				<path
					fill="#fff"
					d="M271.276 24.8c-6.45-2.323-8.29-2.578-10.876-2.306-3.035.319-5.489 1.853-7.426 5.644l-.319.62c-.26.51-.311.688-.29.892s.143.365.548.564l4.151 2.012c.222.115.401.165.574.147.206-.022.334-.139.508-.467l.521-1.02c.811-1.57 1.623-2.138 2.726-2.254.966-.101 2.133.052 3.618.586l4.271 1.483c.435.161.872.011 1.029-.488l1.487-4.433c.156-.5-.014-.792-.522-.98m-18.683-5.59c6.45 2.322 8.29 2.577 10.877 2.306 3.034-.32 5.488-1.854 7.426-5.644l.318-.62c.26-.51.311-.688.29-.893s-.143-.365-.548-.563l-4.151-2.013c-.221-.115-.401-.165-.573-.147-.207.022-.334.139-.509.468l-.52 1.02c-.812 1.569-1.624 2.137-2.727 2.253-.966.101-2.133-.052-3.618-.586l-4.27-1.483c-.436-.16-.873-.011-1.03.488l-1.486 4.433c-.157.5.013.792.521.98"
				/>
			</g>
			<rect width="40" height="40" x="211.981" y="1.98" fill="#282828" rx="10" />
			<rect
				width="39.167"
				height="39.167"
				x="212.398"
				y="2.397"
				stroke="#000"
				strokeOpacity=".1"
				strokeWidth=".833"
				rx="9.583"
			/>
			<g fill="#fff" clipPath="url(#d)">
				<path fillOpacity=".01" d="M219.481 9.48h25v25h-25z" />
				<path d="M232.164 34.404a.55.55 0 0 1-.55-.589.5.5 0 0 1 .104-.267l5.857-8.037-10.256 4.175a.552.552 0 0 1-.746-.348.524.524 0 0 1 .226-.601l9.02-5.308-15.882-.91a.55.55 0 0 1-.456-.541.55.55 0 0 1 .456-.54l15.89-.909-9.022-5.307a.53.53 0 0 1-.226-.6.55.55 0 0 1 .523-.396q.115 0 .22.05l10.258 4.18-5.857-8.034a.517.517 0 0 1-.049-.549.55.55 0 0 1 .492-.315c.145 0 .283.06.383.164l11.673 11.63a.88.88 0 0 1 0 1.249l-11.679 11.644a.53.53 0 0 1-.379.159" />
			</g>
			<path
				fill="#1868db"
				d="M182.727 10.61c.386-5.51 5.164-9.664 10.674-9.279l19.951 1.395c5.509.386 9.663 5.164 9.278 10.674l-1.395 19.951c-.385 5.51-5.164 9.663-10.673 9.278l-19.952-1.395c-5.509-.385-9.663-5.164-9.278-10.673z"
			/>
			<path
				stroke="#000"
				strokeOpacity=".1"
				strokeWidth="1.25"
				d="m193.357 1.955 19.951 1.395a9.376 9.376 0 0 1 8.699 10.006l-1.396 19.951a9.375 9.375 0 0 1-10.006 8.699l-19.951-1.396a9.375 9.375 0 0 1-8.698-10.006l1.395-19.951a9.375 9.375 0 0 1 10.006-8.698Z"
			/>
			<g clipPath="url(#e)">
				<path
					fill="#fff"
					d="m213.732 21.936-6.716-.47 6.051-2.95-1.123-2.302-6.05 2.95 3.764-5.58-2.124-1.432-3.763 5.58.469-6.715-2.554-.178-.47 6.715-2.952-6.05-2.301 1.122 2.951 6.05-5.581-3.764-1.432 2.123 5.581 3.764-6.715-.47-.179 2.555 6.715.47-6.05 2.95 1.122 2.303 6.05-2.95-3.764 5.58 2.123 1.432 3.765-5.581-.47 6.715 2.555.179.469-6.715 2.95 6.05 2.302-1.122-2.95-6.051 5.58 3.764 1.432-2.123-5.58-3.764 6.715.47.178-2.555zm-11.815 3.949a3.497 3.497 0 1 1 .489-6.977 3.497 3.497 0 0 1-.489 6.977"
				/>
			</g>
			<rect width="40" height="40" x="151.981" y="1.98" fill="#fff" rx="10" />
			<rect
				width="39.167"
				height="39.167"
				x="152.398"
				y="2.397"
				stroke="#000"
				strokeOpacity=".1"
				strokeWidth=".833"
				rx="9.583"
			/>
			<path fill="#fff" fillOpacity=".01" d="M159.481 9.48h25v25h-25z" />
			<g clipPath="url(#f)">
				<path
					fill="#0066da"
					d="m161.871 30.456 1.103 1.905c.229.4.558.716.945.945l3.937-6.816h-7.875c0 .444.115.888.344 1.289z"
				/>
				<path
					fill="#00ac47"
					d="m172.481 18.472-3.937-6.816c-.387.23-.716.544-.945.945l-7.274 12.6a2.6 2.6 0 0 0-.344 1.29h7.875z"
				/>
				<path
					fill="#ea4335"
					d="M181.044 33.306c.386-.23.716-.544.945-.945l.458-.788 2.191-3.794c.229-.401.343-.845.343-1.289h-7.876l1.676 3.294z"
				/>
				<path
					fill="#00832d"
					d="m172.481 18.472 3.938-6.816a2.5 2.5 0 0 0-1.289-.344h-5.298c-.458 0-.902.13-1.288.344z"
				/>
				<path
					fill="#2684fc"
					d="M177.106 26.49h-9.25l-3.937 6.816c.386.229.83.344 1.288.344h14.548c.458 0 .902-.13 1.289-.344z"
				/>
				<path
					fill="#ffba00"
					d="m181.001 18.901-3.637-6.3a2.6 2.6 0 0 0-.945-.945l-3.938 6.816 4.625 8.018h7.861c0-.444-.115-.888-.344-1.288z"
				/>
			</g>
			<rect
				width="40"
				height="40"
				x="120"
				y="4.181"
				fill="#1b1f23"
				rx="10"
				transform="rotate(-6 120 4.18)"
			/>
			<g fill="#fff" clipPath="url(#g)">
				<path fillOpacity=".01" d="m128.243 10.856 24.863-2.614 2.613 24.863-24.863 2.614z" />
				<path
					fillRule="evenodd"
					d="M140.68 9.6c-6.869.722-11.847 6.87-11.125 13.738.578 5.5 4.625 9.773 9.74 10.9.633.044.826-.353.792-.68-.031-.295-.149-1.272-.259-2.313-3.063.903-4.011-.349-4.333-1.022-.178-.342-.9-1.382-1.459-1.622-.46-.187-1.142-.697-.102-.822.977-.118 1.773.725 2.045 1.074 1.317 1.762 3.048 1.046 3.729.645.023-.82.293-1.398.617-1.746-2.798-.02-5.801-.789-6.301-5.544-.142-1.352.222-2.521.923-3.475-.157-.297-.726-1.526-.222-3.307 0 0 1.007-.436 3.553.915a11.6 11.6 0 0 1 3.063-.746 11.6 11.6 0 0 1 3.152.092c2.208-1.865 3.285-1.633 3.285-1.633.863 1.637.562 2.957.471 3.281.884.787 1.481 1.84 1.625 3.207.501 4.77-2.293 6.133-5.027 6.734.492.342.959 1.047 1.081 2.212.175 1.663.3 3 .344 3.42.034.327.308.69.917.501 4.737-2.163 7.805-7.199 7.229-12.684-.722-6.869-6.87-11.847-13.738-11.125"
					clipRule="evenodd"
				/>
			</g>
			<path
				stroke="#000"
				strokeOpacity=".1"
				strokeWidth="1.25"
				d="M92.606 2.605h38.75v38.75h-38.75z"
			/>
			<path
				fill="#dddee1"
				d="M91.981 11.98c0-5.522 4.477-10 10-10h20c5.523 0 10 4.478 10 10v20c0 5.523-4.477 10-10 10h-20c-5.523 0-10-4.477-10-10z"
			/>
			<g fill="#101214" clipPath="url(#h)">
				<path d="M116.18 21.98a4.2 4.2 0 1 1-8.398 0 4.2 4.2 0 0 1 8.398 0" />
				<path
					fillRule="evenodd"
					d="M111.981 33.7c6.472 0 11.719-5.247 11.719-11.72 0-6.472-5.247-11.718-11.719-11.718s-11.719 5.246-11.719 11.718c0 6.473 5.247 11.72 11.719 11.72m7.324-11.72a7.324 7.324 0 1 1-14.648 0 7.324 7.324 0 0 1 14.648 0"
					clipRule="evenodd"
				/>
			</g>
			<path
				fill="#1868db"
				d="M62.728 10.61C63.113 5.1 67.89.945 73.4 1.33l19.951 1.395c5.51.386 9.663 5.164 9.278 10.674l-1.395 19.951c-.385 5.51-5.164 9.663-10.673 9.278L70.61 41.234c-5.509-.385-9.663-5.164-9.278-10.673z"
			/>
			<path
				stroke="#000"
				strokeOpacity=".1"
				strokeWidth=".833"
				d="m73.372 1.747 19.95 1.395a9.583 9.583 0 0 1 8.892 10.229l-1.395 19.95c-.369 5.28-4.948 9.261-10.228 8.892L70.64 40.818a9.583 9.583 0 0 1-8.892-10.228l1.396-19.951a9.583 9.583 0 0 1 10.228-8.892Z"
			/>
			<g clipPath="url(#i)">
				<path
					fill="#fff"
					d="m76.54 27.487-2.248-.157c-3.391-.237-5.679-2.485-5.466-5.526l12.09.846c.626.043 1 .517.956 1.147l-.85 12.166c-3.023-.212-4.879-2.802-4.64-6.214zm6.394-5.628-2.248-.157c-3.392-.238-5.681-2.448-5.469-5.489l12.09.845c.626.044 1.04.483.996 1.114l-.85 12.165c-3.023-.211-4.916-2.803-4.677-6.216zm6.428-5.589-2.248-.157c-3.391-.237-5.679-2.484-5.466-5.525l12.09.845c.626.044 1 .517.959 1.11l-.85 12.166c-3.023-.211-4.88-2.801-4.64-6.213z"
				/>
			</g>
			<rect width="40" height="40" x="31.981" y="1.98" fill="#fff" rx="10" />
			<rect
				width="39.167"
				height="39.167"
				x="32.398"
				y="2.397"
				stroke="#000"
				strokeOpacity=".1"
				strokeWidth=".833"
				rx="9.583"
			/>
			<path fill="#fff" fillOpacity=".01" d="M39.481 9.48h25v25h-25z" />
			<path
				fill="#fff"
				d="m58.56 15.401-5.92-.658-7.238.658-.658 6.579.658 6.579 6.58.822 6.578-.822.658-6.743z"
			/>
			<path
				fill="#1a73e8"
				d="M48.101 25.608q-.738-.497-1.018-1.459l1.142-.47q.155.592.542.918.386.325.935.324.56 0 .962-.34.403-.342.403-.867 0-.539-.425-.879-.424-.34-1.062-.34h-.66v-1.13h.593q.547 0 .922-.296t.375-.81a.9.9 0 0 0-.335-.733q-.336-.273-.85-.274-.504-.001-.8.268-.295.27-.43.66l-1.13-.471q.223-.637.827-1.123.605-.486 1.542-.487.694-.001 1.247.268t.867.743q.313.476.312 1.067 0 .605-.29 1.024-.293.419-.716.643v.067q.558.234.917.715.359.48.359 1.152t-.34 1.197q-.343.526-.94.827-.6.302-1.347.303a2.8 2.8 0 0 1-1.602-.497M55.106 19.944l-1.247.907-.626-.95 2.248-1.623h.862v7.65h-1.237z"
			/>
			<path fill="#ea4335" d="m58.56 34.48 5.921-5.92-2.96-1.316-2.96 1.316-1.317 2.96z" />
			<path fill="#34a853" d="m44.086 31.52 1.316 2.96H58.56v-5.92H45.402z" />
			<path
				fill="#4285f4"
				d="M41.455 9.48c-1.09 0-1.974.884-1.974 1.974V28.56l2.96 1.316 2.961-1.316V15.402H58.56l1.316-2.961-1.316-2.96z"
			/>
			<path fill="#188038" d="M39.481 28.56v3.947c0 1.09.883 1.974 1.974 1.974h3.947V28.56z" />
			<path fill="#fbbc04" d="M58.56 15.402V28.56h5.921V15.402l-2.96-1.316z" />
			<path fill="#1967d2" d="M64.481 15.402v-3.948c0-1.09-.883-1.974-1.973-1.974H58.56v5.922z" />
			<rect width="40" height="40" y="4.181" fill="#000" rx="10" transform="rotate(-6 0 4.18)" />
			<rect
				width="39.167"
				height="39.167"
				x=".458"
				y="4.551"
				stroke="#fff"
				strokeOpacity=".1"
				strokeWidth=".833"
				rx="9.583"
				transform="rotate(-6 .458 4.551)"
			/>
			<path
				fill="#fff"
				fillOpacity=".01"
				d="m8.243 10.856 24.863-2.614 2.613 24.863-24.863 2.614z"
			/>
			<path
				fill="#1abcfe"
				d="M22.672 21.909a4.167 4.167 0 1 1 8.287-.872 4.167 4.167 0 0 1-8.287.872"
			/>
			<path
				fill="#0acf83"
				d="M15.255 31.067a4.167 4.167 0 0 1 3.708-4.58l4.144-.435.436 4.144a4.167 4.167 0 0 1-8.288.87"
			/>
			<path fill="#ff7262" d="m21.365 9.477.871 8.287 4.144-.435a4.167 4.167 0 0 0-.871-8.288z" />
			<path
				fill="#f24e1e"
				d="M13.513 14.492a4.167 4.167 0 0 0 4.58 3.708l4.143-.436-.87-8.287-4.145.435a4.166 4.166 0 0 0-3.708 4.58"
			/>
			<path
				fill="#a259ff"
				d="M14.384 22.78a4.167 4.167 0 0 0 4.58 3.708l4.143-.436-.87-8.287-4.145.435a4.166 4.166 0 0 0-3.708 4.58"
			/>
			<defs>
				<clipPath id="a">
					<path
						fill="#fff"
						d="M302.727 10.61c.386-5.51 5.164-9.664 10.674-9.279l19.951 1.395c5.509.386 9.663 5.164 9.278 10.674l-1.395 19.951c-.385 5.51-5.164 9.663-10.673 9.278l-19.952-1.395c-5.509-.385-9.663-5.164-9.278-10.673z"
					/>
				</clipPath>
				<clipPath id="b">
					<path fill="#fff" d="m310.768 9.866 23.771 1.662-1.662 23.771-23.771-1.662z" />
				</clipPath>
				<clipPath id="c">
					<path fill="#fff" d="m250.644 13.274 20.519-2.156 2.062 19.617-20.52 2.156z" />
				</clipPath>
				<clipPath id="d">
					<path fill="#fff" d="M219.481 9.48h25v25h-25z" />
				</clipPath>
				<clipPath id="e">
					<path fill="#fff" d="m187.083 5.066 32.42 2.267-2.266 32.421-32.421-2.267z" />
				</clipPath>
				<clipPath id="f">
					<path fill="#fff" d="M159.981 11.313h25V33.65h-25z" />
				</clipPath>
				<clipPath id="g">
					<path fill="#fff" d="m128.243 10.856 24.863-2.614 2.613 24.863-24.863 2.614z" />
				</clipPath>
				<clipPath id="h">
					<path fill="#fff" d="M93.231 3.23h37.5v37.5h-37.5z" />
				</clipPath>
				<clipPath id="i">
					<path fill="#fff" d="m69.669 9.75 25.1 1.755L93.002 36.8l-25.1-1.755z" />
				</clipPath>
			</defs>
		</svg>
	);
};
